import {Injectable} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormChangeListenerService {
  //check if the host component has changes
  public initializeFormListener(form: FormGroup): void {
    window.onchange = (event: Event): void => {
      const receivedId: string = (event.target as HTMLElement).id;
      const target: HTMLInputElement = event.target as HTMLInputElement;
      //check if the form has the id of the changed element
      if (Object.keys(form.controls).indexOf(receivedId) === -1) {
        //if the form does not have the id of the changed element, return
        return;
      }

      form.controls[receivedId].setValue(target.value);
      form.controls[receivedId].markAsTouched();
      form.updateValueAndValidity();
    };
  }
}
